module.exports = __webpack_public_path__ + "img/ecommerce.category.content_image_4.2d946885.webp";